import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { extractDomain } from "../../utils/helpers";
import { baseQueryWithAuthCheck } from "../../utils/baseQueryWithAuthCheck";
import { endPoints, MIDDLEWARE_SLUG } from "../../apis/apiEndPoints";
import { IInventoryUsageData } from "../../types/campaign.types";

const DOMAIN = extractDomain();

export const campaignListingApi = createApi({
  reducerPath: "campaignListingApi",
  baseQuery: baseQueryWithAuthCheck(
    fetchBaseQuery({
      baseUrl: `${window.location.origin}${MIDDLEWARE_SLUG}/middleware`,
    })
  ),
  endpoints: (builder) => ({
    // start download - useStartDownloadWhatsAppRepliesMutation
    startDownloadWhatsAppReplies: builder.mutation<
      {requestId: string},
      { campaignId: string }
    >({
      query: ({ campaignId }) => ({
        url: `${endPoints.DOWNLOAD_WHATS_APP_REPLIES}`,
        method: "POST",
        headers: {
          domain: DOMAIN,
        },
        body: {
          campaignId,
        },
        withCredentials: true,
      }),
    }),

    // poll for excel download - useDownloadWhatsAppRepliesQuery
    downloadWhatsAppReplies: builder.query<unknown, { requestId: string }>({
      query: ({ requestId }) => ({
        url: `${endPoints.DOWNLOAD_WHATS_APP_REPLIES}?requestId=${requestId}`,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),

    // useTopUpMutation
    topUp: builder.mutation<any, any>({
      query: (body:any) => ({
        url: endPoints.TOP_UP,
        method: "POST",
         headers: {
          domain: DOMAIN,
        },
        body,
      }),
    }),


    // useInventoryUsageMutation
    inventoryUsage: builder.mutation<IInventoryUsageData, { 
        corp_id: number,
        recruiter_id : number,
        channel_id : number,
        subChannel_id : number,
        type : "OS_EMAIL" | "EM"
    }>({
      query: (args) => ({
        url: `${endPoints.INVENTORY_USAGE}`,
        method: "POST",
         headers: {
          domain: DOMAIN,
        },
        body: args,
      }),
    }),

    // useGetRevampServicesQuery
    getRevampServices: builder.query<
      {
        corpId: number;
        enabled: boolean;
      },
      void
    >({
      query: () => ({
        url: `${endPoints.FETCH_REVAMP_SERVICES}`,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
      }),
    }),
  }),
});

export const {
  useDownloadWhatsAppRepliesQuery,
  useStartDownloadWhatsAppRepliesMutation,
  useGetRevampServicesQuery,
  useTopUpMutation,
  useInventoryUsageMutation
} = campaignListingApi;
